import service from '@api/config'

export const getWechatConfig = (data) => {
  return service.request({
    url: `/wx/wxConfig`,
    method: 'post',
    data: data
  })
}
